import { MapPin, Check } from "lucide-react";
import { FOUNDER_IMG } from "./assets";

const HIGHLIGHTS = [
    "30+ curated book clubs with weekly reading schedules",
    "Tinder-style book discovery — swipe to find your perfect match",
    "Ready-to-post social media content for BookTok, Bookstagram & more",
    "Real community — chat rooms, discussions, and private clubs",
    "All-in-one reading tracker, reviews, and statistics",
];

const FounderImage = () => (
    <div className="relative">
        <div className="absolute -inset-4 bg-[#C4956A]/20 rounded-[2.5rem] blur-2xl" />
        <img
            data-testid="founder-image"
            src={FOUNDER_IMG}
            alt="Miracle Martin, founder of BookBlend"
            className="relative rounded-[2rem] w-full max-w-md object-cover h-[480px] shadow-soft"
        />
        <div className="absolute bottom-5 left-5 bg-white/95 backdrop-blur rounded-2xl px-5 py-3 shadow-soft border border-[#E5D7C5]">
            <p className="font-serif text-lg text-[#2D2D2D]">
                Miracle Martin
            </p>
            <p className="text-xs text-[#6B655C] flex items-center gap-1">
                <MapPin size={12} /> Milwaukee, Wisconsin
            </p>
        </div>
    </div>
);

const AboutStory = () => (
    <div>
        <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C4956A]">
            Our story
        </span>
        <h2 className="font-serif text-4xl md:text-5xl leading-tight mt-3">
            Built in 2025, for the people who{" "}
            <span className="italic">still read for joy</span>.
        </h2>
        <p className="mt-6 text-[17px] text-[#6B655C] leading-relaxed font-sans">
            BookBlend was founded in 2025 by Miracle Martin in
            Milwaukee, Wisconsin with a simple mission: to bring
            book lovers together. Whether you're a casual reader
            looking for your next great book, or a content
            creator building your bookish brand on social media,
            BookBlend has everything you need.
        </p>
        <ul className="mt-8 space-y-4 text-[15px] text-[#2D2D2D]">
            {HIGHLIGHTS.map((line) => (
                <li key={line} className="flex items-start gap-3">
                    <span className="mt-0.5 w-6 h-6 rounded-full bg-[#C4956A] text-white flex items-center justify-center flex-shrink-0">
                        <Check size={14} strokeWidth={3} />
                    </span>
                    <span>{line}</span>
                </li>
            ))}
        </ul>
        <p className="mt-8 font-serif text-2xl italic text-[#C4956A]">
            "A cozy home for the people who still read for joy."
        </p>
    </div>
);

export const About = () => (
    <section
        id="about"
        data-testid="about-section"
        className="py-24 md:py-32 bg-[#F5E9D7]/60 border-y border-[#E5D7C5] relative overflow-hidden"
    >
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10 grid md:grid-cols-2 gap-14 lg:gap-20 items-center">
            <FounderImage />
            <AboutStory />
        </div>
    </section>
);
